import React from 'react';
import logo from '../assets/images/hagnostechlogo.webp';
const Header = () => {
  return (
    <div>
    <section>
        {/* <div className='container'>
            <img src={logo}  className=' logo-css' />

        </div> */}
    </section>
    </div>
  );
}

export default Header;